module.exports = __webpack_public_path__ + "media/skype-23266.mp3";